import React from 'react';
import { RocketOutlined, HomeOutlined, CoffeeOutlined, UserOutlined, ScheduleOutlined, CalendarOutlined, ScissorOutlined, RadarChartOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { useNavigate } from "react-router-dom";
import { useCurrentUser } from '../Contexts/UserContext';


const SiderMenu = () => {
    const navigate = useNavigate();
    const user = useCurrentUser();

    if(!user) return null;

    console.log("User", user);
    console.log("Role", user.role);

    const getItem = (label, key, icon) => {
      return {
        key,
        icon,
        label,
      };
    }
    
    const items = [
      getItem('Home', 'home', <HomeOutlined />),
    ];

    if(user.role === "Admin") {
      items.push(
              getItem('Clients', 'clients', <RocketOutlined />),
              getItem('Therapists', 'therapists', <CoffeeOutlined />),
              getItem('Service Coordinators', 'servicecoordinators', <UserOutlined />),
              getItem('Ed Teams', 'edteams', <ScissorOutlined />),
              getItem('IFSP Reports', 'ifspreports', <ScheduleOutlined />),
              getItem('Age Out Reports', 'ageoutreports', <CalendarOutlined />),
              getItem('Clients by Provider Reports', 'clientsbyprovider', <RadarChartOutlined/>)
      );
    }

    if(user.role === "Therapist") {
      items.push(
        getItem('My Clients', 'therapistclients', <RocketOutlined />),
        getItem('Therapist IFSP', 'therapistifsp', <ScheduleOutlined />),
      );
    }
    
    const onClick = (e) => {
      navigate(e.key === "home" ? "/" : `/${e.key}`);
    };

    return(
        <Menu
          onClick={onClick}
          style={{
            top: '35px',
            width: 256,
          }}
          mode="vertical"
          items={items}
        />
    )
};
export default SiderMenu;